import emailjs from '@emailjs/browser'

function send(to_email, subject, html_content) {
  const templateParams = {
    to_email,
    from_name: '行創',
    reply_to: 'no_reply',
    html_content,
    subject,
  }
  try {
    return emailjs.send(
      process.env.REACT_APP_EMAIL_SERVICE_ID,
      process.env.REACT_APP_EMAIL_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAIL_PUBLIC_KEY
    )
  } catch (error) {
    console.error(`寄送失敗`, error)
  }
}

export function sendNewMessage(formValue) {
  const { company_name, name, job_title, email, message } = formValue
  const to_email = process.env.REACT_APP_TARGET_MAIL
  const subject = '【行創】顧客留言通知'
  const htmlContent = `
    <h3>顧客留言</h3>
    <p>公司名稱：${company_name}</p>
    <p>姓名：${name}</p>
    <p>職稱：${job_title}</p>
    <p>E-mail：${email}</p>
    <p>訊息：${message}</p>
`
    
  return send(to_email, subject, htmlContent)
}
